"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlgoliaProductFilters = void 0;
const types_1 = require("../types");
const joinFilterQuery_1 = require("./joinFilterQuery");
const joinRangeFilters_1 = require("./joinRangeFilters");
const quoteString_1 = require("./quoteString");
const getBrandsFilter = (brands) => {
    if (!brands?.length) {
        return undefined;
    }
    return brands.map(brand => `brand:${(0, quoteString_1.quoteString)(brand)}`).join(' OR ');
};
const getClassificationFilter = (classification, conjunction = types_1.Conjunction.AND) => {
    if (!classification) {
        return undefined;
    }
    const matchAtLeastOnceFilter = classification.matchAtLeastOnce
        ?.map(match => `classifications:${match}`)
        .join(' OR ');
    const excludeFilter = classification.exclude
        ?.map(exclude => `NOT classifications:${exclude}`)
        .join(' OR ');
    const matchAllFilter = (0, joinFilterQuery_1.joinFilterQuery)(classification.matchAll?.map(match => `classifications:${match}`) || [], conjunction);
    const filters = [matchAtLeastOnceFilter, excludeFilter, matchAllFilter].filter(Boolean);
    return (0, joinFilterQuery_1.joinFilterQuery)(filters, conjunction);
};
const getParticipantsFilter = (filter) => {
    if (!filter) {
        return undefined;
    }
    return (0, joinRangeFilters_1.joinRangeFilters)(`attributes.${types_1.AttributeName.Participants}`, [filter], true);
};
const getPriceFilter = (price) => {
    if (!price) {
        return undefined;
    }
    if (price.min && price.max) {
        return `price.grossAmount:${price.min} TO ${price.max}`;
    }
    if (price.min) {
        return `price.grossAmount >= ${price.min}`;
    }
    if (price.max) {
        return `price.grossAmount <= ${price.max}`;
    }
    return undefined;
};
const getProductIdFilter = (productIds) => {
    if (!productIds?.length) {
        return undefined;
    }
    return productIds.map(productId => `productId:${productId}`).join(' OR ');
};
const getProductTypeFilter = (productTypes) => {
    if (!productTypes?.length) {
        return undefined;
    }
    return productTypes.map(productType => `productType:${productType}`).join(' OR ');
};
const getTargetGroupFilter = (targetGroup) => {
    if (!targetGroup?.name || !types_1.ScoringFactorMap[targetGroup.name]) {
        return undefined;
    }
    const comparisonSign = targetGroup.minimumScoringLimit === 0 ? '>' : '>=';
    return `scoringFactors.${types_1.ScoringFactorMap[targetGroup.name]} ${comparisonSign} ${targetGroup.minimumScoringLimit}`;
};
const getTopCountriesFilter = (topCountryCodes) => {
    if (!topCountryCodes?.length) {
        return undefined;
    }
    return topCountryCodes.map(countryCode => `locations.countryCode:${countryCode}`).join(' OR ');
};
const getTravelNightsFilter = (rangeFilter) => {
    if (!rangeFilter) {
        return undefined;
    }
    return (0, joinRangeFilters_1.joinRangeFilters)(`attributes.${types_1.AttributeName.TravelNights}`, Array.isArray(rangeFilter) ? rangeFilter : [rangeFilter]);
};
const getProductAttributesFilter = (productAttributes) => {
    if (!productAttributes)
        return undefined;
    return (0, joinFilterQuery_1.joinFilterQuery)(Object.keys(productAttributes)
        .filter(productAttribute => Array.isArray(productAttributes[productAttribute]))
        .map(productAttribute => {
        const filters = productAttributes[productAttribute];
        if (filters?.length && typeof filters[0] === 'string') {
            return (0, joinFilterQuery_1.joinFilterQuery)(filters.map(value => `attributes.${productAttribute}:${(0, quoteString_1.quoteString)(value)}`), types_1.Conjunction.OR);
        }
        return (0, joinRangeFilters_1.joinRangeFilters)(`attributes.${productAttribute}`, filters, productAttribute === types_1.AttributeName.Participants);
    }), types_1.Conjunction.AND);
};
const getAlgoliaProductFilters = (filter) => {
    const priceFilter = getPriceFilter(filter?.price);
    const classificationFilter = getClassificationFilter(filter?.classification);
    const countriesCodeFilter = getTopCountriesFilter(filter?.topCountryCodes);
    const travelNightsFilter = getTravelNightsFilter(filter?.travelNights);
    const productTypeFilter = getProductTypeFilter(filter?.productTypes);
    const productIdFilter = getProductIdFilter(filter?.productId);
    const participantsFilter = getParticipantsFilter(filter?.participants);
    const targetGroupFilter = getTargetGroupFilter(filter?.targetGroup);
    const brandsFilter = getBrandsFilter(filter?.brands);
    const productAttributesFilter = getProductAttributesFilter(filter?.productAttributes);
    const inPreviewFilter = filter?.includePreviewProducts ? undefined : 'inPreview:false';
    const isTestProductFilter = filter?.includeTestProducts ? undefined : 'isTestProduct:false';
    const giftBoxIdFilter = filter?.giftBoxId ? `giftboxList: ${filter.giftBoxId}` : undefined;
    const isSellableProductFilter = filter?.isShoppingFlow ? 'isSellable:true' : undefined;
    return (0, joinFilterQuery_1.joinFilterQuery)([
        priceFilter,
        classificationFilter,
        countriesCodeFilter,
        travelNightsFilter,
        productTypeFilter,
        productIdFilter,
        participantsFilter,
        targetGroupFilter,
        brandsFilter,
        productAttributesFilter,
        inPreviewFilter,
        isTestProductFilter,
        giftBoxIdFilter,
        isSellableProductFilter,
    ], types_1.Conjunction.AND);
};
exports.getAlgoliaProductFilters = getAlgoliaProductFilters;
//# sourceMappingURL=getAlgoliaProductFilters.js.map